module.exports = __webpack_public_path__ + "bfe074eb833ab07ed702b4919e409f55.MP3";